var map = {
	"./b.png": "quB7",
	"./back.png": "Zeu4",
	"./banner.png": "FgRc",
	"./code.png": "YUxC",
	"./detaile_banner.png": "NFlR",
	"./f.png": "jjqn",
	"./ifeng_logo.png": "vKmw",
	"./mainCover.png": "1v3h",
	"./more.png": "BSsy",
	"./photo.png": "DMYj",
	"./r.png": "NYW3",
	"./share.png": "xsxf",
	"./share_bottom-2.png": "pnjG",
	"./share_bottom.png": "hy9A",
	"./share_w.png": "Co8G",
	"./star.png": "kY38",
	"./title_icon.png": "T2wS",
	"./title_icon2.png": "nAgq",
	"./x.png": "CJxh"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZZIV";